var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4194 10C15.4194 7.00697 12.993 4.58065 10 4.58065C7.00697 4.58065 4.58065 7.00697 4.58065 10C4.58065 12.993 7.00697 15.4194 10 15.4194C12.993 15.4194 15.4194 12.993 15.4194 10ZM18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9846 21.753L13.4266 15.195L15.1944 13.4273L21.7524 19.9853L19.9846 21.753Z",
    fill: "currentColor"
  })));
};
export default SvgSearch;